import React from 'react';
import { Box, Button } from '@mui/material';
import { AISummaryStartFormProp } from './types';
import { useTranslation } from 'react-i18next';
import styles from '../AISummaryDetails.module.scss';

export const AISummaryStartForm = ({ handleBtnClick }: AISummaryStartFormProp) => {
  const { t } = useTranslation();
  return (
    <Box maxWidth='300px' display='flex' alignItems='center' justifyContent='center' margin='auto'>
      <Box
        display='flex'
        flexDirection='column'
        gap='24px'
        alignItems='center'
        justifyContent='center'
      >
        <Box className={styles.empty_state_message}>{t('emptyStateMessages.aiSummary')}</Box>
        <Box>
          <Button
            type='button'
            className='btn-default btn-action-basic btn-large'
            role='button'
            variant='contained'
            onClick={handleBtnClick}
          >
            {t('buttons.start')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
